module.exports = __webpack_public_path__ + "img/grace.a920749e.png";